
import React from 'react';
import Hero from '@/components/Hero';

// Import refactored components
import PressResourcesCard from '@/components/press-kit/PressResourcesCard';
import AboutSection from '@/components/press-kit/AboutSection';
import TourHighlights from '@/components/press-kit/TourHighlights';
import MediaContact from '@/components/press-kit/MediaContact';
import FAQSection from '@/components/press-kit/FAQSection';
import TestimonialsSection from '@/components/press-kit/TestimonialsSection';
import SocialLinks from '@/components/press-kit/SocialLinks';
import { tourHighlights, faqs } from '@/components/press-kit/constants';

const PressKit = () => {
  return (
    <div className="min-h-screen pb-16">
      {/* Hero Section - Updated to remove overlay */}
      <Hero 
        title="Press Kit" 
        subtitle="Resources for media and journalists"
        backgroundImage="/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png"
        height="medium"
        imageStyle="natural"
        overlay={false}
      />

      {/* Main Content */}
      <div className="container mx-auto px-4 md:px-8 py-12">
        {/* Press Resource Link */}
        <PressResourcesCard />
        
        {/* About Section */}
        <AboutSection />
        
        {/* Tour Highlights */}
        <TourHighlights highlights={tourHighlights} />
        
        {/* Media Contact */}
        <MediaContact />
        
        {/* FAQs */}
        <FAQSection faqs={faqs} />
        
        {/* Testimonials */}
        <TestimonialsSection />
        
        {/* Social Media */}
        <SocialLinks />
      </div>
    </div>
  );
};

export default PressKit;
